import React from 'react';

// Small segmented control: options = [[value, label], ...].
export const Segmented = ({ value, options, onChange, testId }) => (
  <div className="grid gap-1 rounded-lg bg-slate-100 p-1 mt-1" style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }} role="radiogroup">
    {options.map(([v, label]) => (
      <button key={v} type="button" role="radio" aria-checked={value === v} onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
        className={`rounded-md px-2 py-1.5 text-xs font-semibold transition-[background-color,color,box-shadow] duration-150 ${
          value === v ? 'bg-white text-[#00247D] shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
        {label}
      </button>
    ))}
  </div>
);
